import React, { useState } from 'react';
import { FaWifi, FaEye, FaEdit, FaTrash, FaPlus, FaExclamationTriangle } from 'react-icons/fa';
import ofertasService from '../../helpers/ofertasService';

const OfertasOfflineMode = ({ onRetry, onGoOnline }) => {
    const [showDemo, setShowDemo] = useState(false);

    // Datos de demostración
    const demoOfertas = [
        {
            _id: 'demo-1',
            nombre: 'Descuento Verano 20%',
            descripcion: 'Aprovecha el 20% de descuento en toda la colección de verano',
            tipo: 'DESCUENTO_PORCENTAJE',
            estado: 'ACTIVA',
            porcentajeDescuento: 20,
            importeMinimo: 50,
            usosMaximosGlobales: 1000,
            usosMaximosPorCliente: 1,
            fechaInicio: '2024-06-01T00:00:00.000Z',
            fechaFin: '2024-08-31T23:59:59.000Z',
            objetivoPrincipal: 'AUMENTAR_VENTAS',
            aplicabilidad: 'AMBOS',
            canalesDifusion: ['EMAIL'],
            mensajePromocional: '¡Verano con 20% OFF!',
            callToAction: 'Comprar Ahora',
            etiquetas: ['verano', 'descuento', 'coleccion'],
            visualizaciones: 1250,
            clicks: 320,
            usos: 45,
            conversiones: 45,
            ventasGeneradas: 2250.00,
            activo: true,
            createdAt: '2024-01-15T10:30:00.000Z',
            updatedAt: '2024-01-15T10:30:00.000Z'
        },
        {
            _id: 'demo-2',
            nombre: 'Bienvenida - 10€ de Regalo',
            descripcion: 'Como nuevo cliente, disfruta de 10€ de descuento en tu primera compra',
            tipo: 'DESCUENTO_FIJO',
            estado: 'ACTIVA',
            descuentoFijo: 10,
            importeMinimo: 30,
            usosMaximosGlobales: 500,
            usosMaximosPorCliente: 1,
            fechaInicio: '2024-01-01T00:00:00.000Z',
            fechaFin: '2024-12-31T23:59:59.000Z',
            objetivoPrincipal: 'CAPTAR_NUEVOS_CLIENTES',
            aplicabilidad: 'AMBOS',
            canalesDifusion: ['EMAIL'],
            mensajePromocional: '¡Bienvenido! 10€ de regalo',
            callToAction: 'Usar Descuento',
            etiquetas: ['nuevos-clientes', 'bienvenida', 'primera-compra'],
            visualizaciones: 800,
            clicks: 200,
            usos: 120,
            conversiones: 120,
            ventasGeneradas: 3600.00,
            activo: true,
            createdAt: '2024-01-01T00:00:00.000Z',
            updatedAt: '2024-01-01T00:00:00.000Z'
        },
        {
            _id: 'demo-3',
            nombre: '2x1 Electrónicos',
            descripcion: 'Lleva 2 productos y paga solo 1',
            tipo: 'DOS_POR_UNO',
            estado: 'PAUSADA',
            cantidadMinima: 2,
            usosMaximosGlobales: 500,
            usosMaximosPorCliente: 2,
            fechaInicio: '2024-02-01T00:00:00.000Z',
            fechaFin: '2024-02-29T23:59:59.000Z',
            objetivoPrincipal: 'AUMENTAR_VENTAS',
            aplicabilidad: 'AMBOS',
            canalesDifusion: ['EMAIL'],
            mensajePromocional: '¡2x1 en Electrónicos!',
            callToAction: 'Aprovechar Oferta',
            etiquetas: ['2x1', 'electronicos', 'promocion'],
            visualizaciones: 600,
            clicks: 150,
            usos: 75,
            conversiones: 75,
            ventasGeneradas: 4500.00,
            activo: true,
            createdAt: '2024-02-01T00:00:00.000Z',
            updatedAt: '2024-02-01T00:00:00.000Z'
        }
    ];

    const formatValue = (oferta) => {
        return ofertasService.formatOfertaValue(oferta);
    };

    const getEstadoColor = (estado) => {
        return ofertasService.getEstadoColor(estado);
    };

    const getTipoIcon = (tipo) => {
        return ofertasService.getTipoIcon(tipo);
    };

    return (
        <div className="min-h-screen bg-gray-100">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8">
                {/* Header */}
                <div className="mb-8">
                    <div className="flex items-center justify-between">
                        <div>
                            <h1 className="text-3xl font-bold text-gray-800 mb-2">
                                Gestión de Ofertas
                            </h1>
                            <p className="text-gray-600">
                                Administra todas tus ofertas promocionales para aumentar ventas y fidelizar clientes
                            </p>
                        </div>
                        <div className="flex items-center space-x-4">
                            <div className="flex items-center text-red-600">
                                <FaExclamationTriangle className="mr-2" />
                                <span className="text-sm font-medium">Modo Offline</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Offline Banner */}
                <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-6">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center">
                            <FaExclamationTriangle className="text-red-500 mr-3" />
                            <div>
                                <h3 className="text-sm font-medium text-red-800">
                                    Sin conexión al servidor
                                </h3>
                                <p className="text-sm text-red-700 mt-1">
                                    No se puede conectar con el backend. Algunas funcionalidades están limitadas.
                                </p>
                            </div>
                        </div>
                        <div className="flex space-x-2">
                            <button
                                onClick={onRetry}
                                className="text-sm bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700 transition-colors"
                            >
                                Reintentar Conexión
                            </button>
                            <button
                                onClick={() => setShowDemo(!showDemo)}
                                className="text-sm bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 transition-colors"
                            >
                                {showDemo ? 'Ocultar' : 'Ver'} Demo
                            </button>
                        </div>
                    </div>
                </div>

                {/* Demo Mode */}
                {showDemo && (
                    <div className="mb-6">
                        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                            <div className="flex items-center">
                                <FaEye className="text-blue-500 mr-3" />
                                <div>
                                    <h3 className="text-sm font-medium text-blue-800">
                                        Modo Demostración
                                    </h3>
                                    <p className="text-sm text-blue-700 mt-1">
                                        Mostrando datos de ejemplo. Las funcionalidades están deshabilitadas.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Estadísticas Demo */}
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                            <div className="bg-white p-4 rounded-lg shadow-md">
                                <div className="flex items-center">
                                    <div className="text-blue-500 text-2xl mr-3">📊</div>
                                    <div>
                                        <p className="text-sm text-gray-600">Total Ofertas</p>
                                        <p className="text-2xl font-bold text-gray-800">{demoOfertas.length}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-white p-4 rounded-lg shadow-md">
                                <div className="flex items-center">
                                    <div className="text-green-500 text-2xl mr-3">✅</div>
                                    <div>
                                        <p className="text-sm text-gray-600">Ofertas Activas</p>
                                        <p className="text-2xl font-bold text-gray-800">
                                            {demoOfertas.filter(o => o.estado === 'ACTIVA').length}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-white p-4 rounded-lg shadow-md">
                                <div className="flex items-center">
                                    <div className="text-purple-500 text-2xl mr-3">📈</div>
                                    <div>
                                        <p className="text-sm text-gray-600">Total Usos</p>
                                        <p className="text-2xl font-bold text-gray-800">
                                            {demoOfertas.reduce((total, oferta) => total + (oferta.usos || 0), 0)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-white p-4 rounded-lg shadow-md">
                                <div className="flex items-center">
                                    <div className="text-orange-500 text-2xl mr-3">👁️</div>
                                    <div>
                                        <p className="text-sm text-gray-600">Total Visualizaciones</p>
                                        <p className="text-2xl font-bold text-gray-800">
                                            {demoOfertas.reduce((total, oferta) => total + (oferta.visualizaciones || 0), 0)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Ofertas Demo */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {demoOfertas.map((oferta) => (
                                <div key={oferta._id} className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 opacity-75">
                                    <div className="p-6">
                                        {/* Header */}
                                        <div className="flex items-start justify-between mb-4">
                                            <div className="flex items-center">
                                                <div className={`text-2xl ${getTipoIcon(oferta.tipo)}`}>🏷️</div>
                                                <div className="ml-3">
                                                    <h3 className="text-lg font-semibold text-gray-800 truncate">
                                                        {oferta.nombre}
                                                    </h3>
                                                    <p className="text-sm text-gray-600">
                                                        {oferta.tipo.replace(/_/g, ' ')}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="flex items-center space-x-2">
                                                <span className={`px-2 py-1 rounded-full text-xs font-medium ${getEstadoColor(oferta.estado)}`}>
                                                    {oferta.estado}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Descripción */}
                                        <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                                            {oferta.descripcion}
                                        </p>

                                        {/* Valor de la oferta */}
                                        <div className="bg-gray-50 p-3 rounded-lg mb-4">
                                            <div className="text-center">
                                                <span className="text-2xl font-bold text-gray-800">
                                                    {formatValue(oferta)}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Métricas rápidas */}
                                        <div className="grid grid-cols-3 gap-2 mb-4 text-xs">
                                            <div className="text-center">
                                                <div className="font-semibold text-gray-800">{oferta.visualizaciones || 0}</div>
                                                <div className="text-gray-500">Visualizaciones</div>
                                            </div>
                                            <div className="text-center">
                                                <div className="font-semibold text-green-600">{oferta.usos || 0}</div>
                                                <div className="text-gray-500">Usos</div>
                                            </div>
                                            <div className="text-center">
                                                <div className="font-semibold text-blue-600">
                                                    {oferta.visualizaciones > 0 ? ((oferta.usos / oferta.visualizaciones) * 100).toFixed(1) : 0}%
                                                </div>
                                                <div className="text-gray-500">Conversión</div>
                                            </div>
                                        </div>

                                        {/* Acciones deshabilitadas */}
                                        <div className="flex justify-between items-center pt-4 border-t border-gray-200">
                                            <div className="flex space-x-2">
                                                <button
                                                    disabled
                                                    className="p-2 text-gray-400 cursor-not-allowed rounded-lg"
                                                    title="Funcionalidad deshabilitada en modo offline"
                                                >
                                                    <FaEye size={16} />
                                                </button>
                                                <button
                                                    disabled
                                                    className="p-2 text-gray-400 cursor-not-allowed rounded-lg"
                                                    title="Funcionalidad deshabilitada en modo offline"
                                                >
                                                    <FaEdit size={16} />
                                                </button>
                                            </div>
                                            <button
                                                disabled
                                                className="p-2 text-gray-400 cursor-not-allowed rounded-lg"
                                                title="Funcionalidad deshabilitada en modo offline"
                                            >
                                                <FaTrash size={16} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Botón crear deshabilitado */}
                        <div className="mt-6 text-center">
                            <button
                                disabled
                                className="bg-gray-400 text-white px-6 py-2 rounded-lg cursor-not-allowed flex items-center mx-auto"
                            >
                                <FaPlus className="mr-2" />
                                Nueva Oferta (Deshabilitado en modo offline)
                            </button>
                        </div>
                    </div>
                )}

                {/* Información de conexión */}
                <div className="bg-white rounded-lg shadow-md p-6">
                    <h3 className="text-lg font-semibold text-gray-800 mb-4">
                        Información de Conexión
                    </h3>
                    <div className="space-y-3">
                        <div className="flex items-center justify-between">
                            <span className="text-sm text-gray-600">Estado del servidor:</span>
                            <span className="text-sm font-medium text-red-600">Desconectado</span>
                        </div>
                        <div className="flex items-center justify-between">
                            <span className="text-sm text-gray-600">Última conexión:</span>
                            <span className="text-sm font-medium text-gray-800">N/A</span>
                        </div>
                        <div className="flex items-center justify-between">
                            <span className="text-sm text-gray-600">Modo actual:</span>
                            <span className="text-sm font-medium text-blue-600">Offline</span>
                        </div>
                    </div>
                    <div className="mt-4 pt-4 border-t">
                        <p className="text-sm text-gray-600">
                            Para usar todas las funcionalidades, asegúrate de que el servidor esté funcionando y
                            que tengas conexión a internet.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OfertasOfflineMode;
